import script from "./AncientBooks.vue?vue&type=script&lang=ts&setup=true"
export * from "./AncientBooks.vue?vue&type=script&lang=ts&setup=true"

import "./AncientBooks.vue?vue&type=style&index=0&id=5a516592&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a516592"]])

export default __exports__